<template>
  <div id="Bannerlist">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">頁面管理</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">頁腳</li>
              <li class="breadcrumb-item active">頁面管理</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="b-banner" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10">
            <div class="b-filter"></div>
          </div>
          <div class="col-sm-2">
            <el-button style="width: 100%" type="primary" @click="add()"
              ><i class="nav-icon fas fa-pen fa-sm mr-1"></i>新增</el-button
            >
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="demo-input-size row margs"></div>
              <div class="card-body">
                <el-form
                  ref="form"
                  label-width="80px"
                  @submit.native.prevent
                  :inline="true"
                >
                  <el-row>
                    <el-col
                      :md="{ span: 24 }"
                      :sm="{ span: 24 }"
                      :xs="{ span: 24 }"
                      style="text-align: right"
                    >
                      <el-form-item label="搜尋:">
                        <el-input
                          placeholder="请输入内容"
                          v-model="searchText"
                          clearable
                          @input="searchTextQry"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>

                <el-table
                  :data="GetList"
                  v-loading="loading"
                  border
                  row-key="id"
                >
                  <el-table-column label="頁面名稱" prop="title">
                    <template slot-scope="scope">
                      <router-link
                        :to="{ path: `/foot/${scope.row.sgL_RequestUrl}` }"
                        target="_blank"
                      >
                        {{ scope.row.title }}
                      </router-link>
                    </template>
                  </el-table-column>
                  <el-table-column label="URL重寫" prop="sgL_RequestUrl">
                  </el-table-column>
                  <el-table-column label="最後修改日期" prop="sgL_UpdateTimeS">
                  </el-table-column>
                  <el-table-column label="最後修改人員" prop="sgL_UpdateName">
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="add(scope.row.id)"
                        >編輯</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="del(scope.row.id, scope.row.title)"
                        >刪除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- /.card-body -->
            </div>
            <div class="row">
              <div class="col-lg-4 offset-lg-7">
                <!--  引用分页组件 -->
                <pagination
                  v-if="pageParams.pageshow"
                  :currentPage="pageParams.currentPage"
                  :total="pageParams.total"
                  :limit="pageParams.limit"
                  :small="true"
                  @handleCurrentChange="handleCurrentChange"
                  @handleSizeChange="handleSizeChange"
                />
              </div>
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
export default {
  data() {
    return {
      form: {
        SGL_Content: "",
      },
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "true",
          label: "顯示中",
        },
        {
          value: "false",
          label: "隱藏中",
        },
      ],
      SGL_MenuPersionName: "",
      dialogVisible: false,
      dialogContent: "",
      searchText: "",
      selectValue: "",
      BannerList: null,
      pageParams: {
        pageshow: true,
        currentPage: 1, //當前頁
        total: 0, //總條數
        limit: 10, //顯示條數
      },
      loading: true,
    };
  },
  created() {
    this.getBannerList();
  },
  watch: {
    selectValue: {
      handler(newvalue, oldvalue) {
        this.handleCurrentChange(1);
      },
    },
  },
  methods: {
    add(id) {
      this.$router.push({
        name: "footContentEdit",
        query: {
          id,
        },
      });
    },
    del(id, name) {
      let msg = `確認刪除頁面「${name}」?`;
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.permissionApi
          .deleteFootContentInfo({ id })
          .then((res) => {
            Message({
              type: "success",
              message: "刪除成功",
            });
            this.getBannerList();
          })
          .catch((err) => {
            Message({
              type: "error",
              message: err,
            });
          });
      });
    },
    getBannerList() {
      this.loading = true;
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        SGL_Content: this.form.SGL_Content,
      };
      this.$api.permissionApi
        .GetFootContentList(params)
        .then((res) => {
          if (res.data.success) {
            this.BannerList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
          } else {
            Message({
              type: "error",
              message: res.data.error.message,
            });
          }
        })
        .catch((err) => {
          Message({
            type: "error",
            message: err,
          });
          this.loading = false;
        })
        .then((obj) => {
          this.loading = false;
        });
    },
    selectByType(status) {
      this.selectValue = status;
    },
    searchTextQry() {
      this.handleCurrentChange(1);
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.getBannerList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.getBannerList();
    },
  },
  components: {
    pagination,
  },
  computed: {
    GetList() {
      return this.BannerList;
    },
  },
};
</script>

<style scoped>
.filter .current {
  background-color: #2e3e4a;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminFooter/page.vue